import React, { useEffect, useState } from 'react';
import { Badge } from 'antd';
import styles from './index.less';
import classNames from 'classnames';
import ColorPickerWithPresets, { LEAD_STATUS_COLORS } from '@/components/ColorPicker';


export const LeadStateColor = ({color, isCurrent = false, onClick}: {
  color: string,
  isCurrent?: boolean,
  onClick?: () => void
}) => {
  return <div onClick={onClick}>
    <Badge className={classNames(styles.statusColorBadge, {
      [styles.activeBadge]: isCurrent
    })} color={color} style={{borderColor: color}}/>
  </div>
}

type ILeadStateColorPopoverProps = {
  color: string,
  onSelect: (color: string) => void,
  defaultOpen: boolean,
  onOpenChange: (open: boolean) => void,
  popoverPlacement?: string
}
export const LeadStateColorPopover = ({color, onSelect, defaultOpen, onOpenChange, popoverPlacement}: ILeadStateColorPopoverProps) => {
  const [open, setOpen] = useState<boolean>(defaultOpen)

  useEffect(() => {
    handleOpenChange(defaultOpen)
  }, [defaultOpen]);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen)
    onOpenChange(newOpen)
  }
  return <ColorPickerWithPresets value={color} onChange={onSelect} />
}

export const CustomColorPicker = ({value, onChange, disabled = false}) => {
  const [open, setOpen] = useState(false)
  if (disabled) return <LeadStateColor color={value || LEAD_STATUS_COLORS[0]} />
  return <LeadStateColorPopover popoverPlacement={"left"} color={value || LEAD_STATUS_COLORS[0]} onSelect={onChange} defaultOpen={false} onOpenChange={setOpen}/>
}
